import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { categoryService } from '@/api/services/categoryService'

export function useCategories(p?: Parameters<typeof categoryService.list>[0]) {
  return useQuery({ queryKey: ['categories', p], queryFn: () => categoryService.list(p), staleTime: 60_000 })
}
export function useCreateUpdateCategory() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (d: Record<string, unknown>) => categoryService.createUpdate(d), onSuccess: () => qc.invalidateQueries({ queryKey: ['categories'] }) })
}
export function useDeleteCategory() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (id: number) => categoryService.delete(id), onSuccess: () => qc.invalidateQueries({ queryKey: ['categories'] }) })
}
